import { useQuery } from '@tanstack/react-query';
import { getLiveMenuItems, type LiveMenuItems } from '../../api/liveMenuItems';
import { STALE_TIME_LIVE_MENU, ONE_HOUR_IN_MS } from '../../constants';

export const liveMenuItemsQueryKey = (storeNumber: string) =>
  ['live-menu-items', storeNumber] as const;

/**
 * Loads the union of items on a store's LIVE published menus in the background
 * for the menu-aware snooze picker. Call it at the surface level (as soon as a
 * store is selected) so the data is warm by the time the snooze dialog opens.
 */
export function useLiveMenuItems(storeNumber: string | null | undefined) {
  return useQuery<LiveMenuItems>({
    queryKey: liveMenuItemsQueryKey(storeNumber || ''),
    queryFn: () => getLiveMenuItems(storeNumber as string),
    enabled: !!storeNumber,
    staleTime: STALE_TIME_LIVE_MENU,
    gcTime: ONE_HOUR_IN_MS,
    // The fetch is slow-ish (a few seconds cold); don't triple-retry it —
    // the picker falls back to catalog search on failure anyway.
    retry: 1,
  });
}
